import SafeguardProApp from './safeguardpro/SafeguardProApp';

function App() {
  return <SafeguardProApp />;
}

export default App;
